import { useDispatch } from 'react-redux';
import {
  updateMainFiltersROComparisonPeriod,
  updateMainFiltersROPeriod,
  updateMainFiltersROPeriodicity,
  updateMainFiltersROCustomMonthsPeriodState,
  updateMainFiltersROCustomWeeksPeriodState,
} from '@state/actions/main-filter-retailer-overview/MainFiltersRetailerOverviewAction';
import {
  updateMainFiltersComparisonPeriod,
  updateMainFiltersCustomMonthsPeriodState,
  updateMainFiltersCustomWeeksPeriodState,
  updateMainFiltersPeriod,
  updateMainFiltersPeriodicity,
} from '@state/actions/main-filter/MainFiltersAction';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { CustomMonthsPeriodState, CustomWeeksPeriodState } from '@state/reducers/main-filter/MainFiltersReducer';
import {
  updateMainFiltersMPComparisonPeriod,
  updateMainFiltersMPCustomMonthsPeriodState,
  updateMainFiltersMPCustomWeeksPeriodState,
  updateMainFiltersMPPeriod,
  updateMainFiltersMPPeriodicity,
} from '@state/actions/main-filter-market-premium/MainFiltersMarketPremiumAction';

export const useUpdatePerfPeriodSet = () => {
  const dispatch = useDispatch();

  const updatePeriod = (period: BaseTimePeriod) => {
    dispatch(updateMainFiltersPeriod(period));
    dispatch(updateMainFiltersROPeriod(period));
    dispatch(updateMainFiltersMPPeriod(period));
  };

  const updatePeriodicity = (periodicity: Periodicity) => {
    dispatch(updateMainFiltersPeriodicity(periodicity));
    dispatch(updateMainFiltersROPeriodicity(periodicity));
    dispatch(updateMainFiltersMPPeriodicity(periodicity));
  };

  const updateComparisonPeriod = (comparisonPeriod: RelativePeriod | BaseTimePeriod) => {
    dispatch(updateMainFiltersComparisonPeriod(comparisonPeriod));
    dispatch(updateMainFiltersROComparisonPeriod(comparisonPeriod));
    dispatch(updateMainFiltersMPComparisonPeriod(comparisonPeriod));
  };

  const updateCustomMonthsPeriodState = (customMonthsPeriodState: CustomMonthsPeriodState) => {
    dispatch(updateMainFiltersCustomMonthsPeriodState(customMonthsPeriodState));
    dispatch(updateMainFiltersROCustomMonthsPeriodState(customMonthsPeriodState));
    dispatch(updateMainFiltersMPCustomMonthsPeriodState(customMonthsPeriodState));
  };

  const updateCustomWeeksPeriodState = (customWeeksPeriodState: CustomWeeksPeriodState) => {
    dispatch(updateMainFiltersCustomWeeksPeriodState(customWeeksPeriodState));
    dispatch(updateMainFiltersROCustomWeeksPeriodState(customWeeksPeriodState));
    dispatch(updateMainFiltersMPCustomWeeksPeriodState(customWeeksPeriodState));
  };

  return {
    updatePeriod,
    updatePeriodicity,
    updateComparisonPeriod,
    updateCustomMonthsPeriodState,
    updateCustomWeeksPeriodState,
  };
};
